/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import FiltersAction from './FiltersAction/index'
import NoSearchResult from 'DesignSystem/Images/NoSearchResult/index'
import React from 'react'
import SupportLink from './SupportLink/index'
import TagLabel from 'DesignSystem/TagLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/Search/Professional/Search/Content/Profiles/Empty"
  
}) {
  let isBefore = useIsBefore()
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtTypographyTitleFontweight = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.title.fontWeight'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-4PwO0': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<NoSearchResult
  viewPath={`${viewPath}/NoSearchResult`}
 width={150}
 height="auto"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceL}
 fontSize={22}
 fontFamily="Inter"
 fontWeight={dtTypographyTitleFontweight}
 color={dtColorsNeutral600}
 text="No matches found"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Or try to refine your search:"
/>
<div
  data-testid="Empty.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-2-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 tagText="MM/DD/YYYY"
 labelText="Date of birth"
 width={100}
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={dtSpaceXxs}
 tagText="1234A"
 labelText="Human ID"
 width={100}
/>
<FiltersAction
  viewPath={`${viewPath}/FiltersAction`}
/>
</div>
<SupportLink
  viewPath={`${viewPath}/SupportLink`}
/>
</div>
{children}
</React.Fragment>)
}